import { useState } from 'react';

type LandingImageProps = {
	src: string;
	alt: string;
	className?: string;
	width?: number | string;
	height?: number | string;
	eager?: boolean;
	priority?: boolean;
};

export const LandingImage = ({
	src,
	alt,
	className,
	width,
	height,
	eager,
	priority,
}: LandingImageProps) => {
	const [hidden, setHidden] = useState(false);
	const imgProps: Record<string, string> = {};
	if (priority) imgProps.fetchpriority = 'high';
	return (
		<img
			src={src}
			alt={alt}
			className={className}
			width={width}
			height={height}
			loading={eager ? 'eager' : 'lazy'}
			decoding="async"
			onError={() => setHidden(true)}
			style={hidden ? { visibility: 'hidden' } : undefined}
			{...imgProps}
		/>
	);
};
